{
  "recommendationAccepted": null,
  "numberOfDocumentsRequested": 0,
  "setCompletionDateForEmail": "2026-06-23T12:30:01.492Z",
  "opportunityOwnerTextForEmail": "Mojo Mortgages Dev Mode",
  "ownerEmailAddress": "devmode@mojomortgages.com"
}